// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__pqHMG","image":"Header_image__1zCXm","name":"Header_name__2pWYb","info":"Header_info__368qM","infoRow":"Header_infoRow__1Vp3Y"};